import styles from './PreviewStackDialog.module.css'

type ExistingStackDividerProps = {
  stackNumber: number
}

export function ExistingStackDivider({stackNumber}: ExistingStackDividerProps) {
  const label = `Already in stack #${stackNumber}`
  return (
    <li aria-label={label} className={styles.groupDivider}>
      <span className={styles.groupDividerLabel}>{label}</span>
    </li>
  )
}
